import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a telephone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please provide an event date' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide a guest count' },
      ]
    },
    SiteName: {
        validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Contact Phone Number:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Venue:',
            mapping: 'SiteName'
        }
    ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How Did You Hear About Us?:',
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Pisces Rising Catering Contact Form ',
    formId: '831',
    clientKey: '5BEB1CD4-8562-4FBE-8464-E04B25B6FA43',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
